import React from 'react';
import DetailsBox from '../common/DetailsBox/DetailsBox';
import StatsWidget from '../common/StatsWidget/StatsWidget';
import StatsWidgetChart from '../common/StatsWidgetChart/StatsWidgetChart';

const Landing = () => {
    return (
        <DetailsBox>
            <StatsWidgetChart
                title="Bandwidth"
                statsnumbers="309,841"
                statspercents="42,730"
                tooltip="Total bandwidth shared and used across the network."
            />
            <StatsWidget
                title="Block Height"
                statsnumbers="1,095,846"
                statspercents="42,730"
                tooltip="Current height of the Sentinel Blockchain."
                url="blockchain"
            />
            <StatsWidget
                title="Market Price"
                statsnumbers="50.40"
                statspercents="0.83"
                tooltip="Data provided by CoinGecko."
                url="market"
            />
            <StatsWidget
                title="dVPN Nodes"
                statsnumbers="112"
                statspercents="4.24"
                tooltip="Number of active dVPN nodes on the network."
                url="nodes"
            />
            <StatsWidget
                title="DVPN Staked"
                statsnumbers="27.71M"
                statspercents="614,765,900.00"
                tooltip="Number of $DVPN staked, securing the network."
                url="validators"
            />
            <StatsWidget
                title="Market Cap"
                statsnumbers="215.00 M"
                tooltip="Data provided by CoinGecko."
                url="market"
            />
            <StatsWidget
                title="Validators"
                statsnumbers="309,841"
                tooltip="Number of active validators securing Sentinel’s Blockchain."
                url="validators"
            />
        </DetailsBox>
    )
}

export default Landing
